import { render, staticRenderFns } from "./agentBuyCardCostConfig.vue?vue&type=template&id=57f554c2&scoped=true&"
import script from "./agentBuyCardCostConfig.vue?vue&type=script&lang=js&"
export * from "./agentBuyCardCostConfig.vue?vue&type=script&lang=js&"
import style0 from "./agentBuyCardCostConfig.vue?vue&type=style&index=0&id=57f554c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f554c2",
  null
  
)

export default component.exports